import React from "react";
import { Link } from "react-router-dom";
import { Container } from "@/components/shared";
import { Button } from "@/components/ui/button";
import { Compass, Home } from "lucide-react";

export default function NotFound() {
  return (
    <Container className="flex min-h-[70vh] flex-col items-center justify-center py-20 text-center">
      <div className="font-heading text-7xl font-extrabold text-ff-blue">404</div>
      <h1 className="mt-4 font-heading text-2xl font-bold text-ff-blue">We couldn't find that page</h1>
      <p className="mt-2 max-w-md text-ff-dark">The page may have moved or the link may be broken. Let's get you back on track.</p>
      <div className="mt-8 flex flex-col gap-3 sm:flex-row">
        <Button asChild className="bg-ff-action font-semibold text-white hover:bg-ff-actionDark">
          <Link to="/" data-testid="notfound-home"><Home className="mr-2 h-4 w-4" /> Go home</Link>
        </Button>
        <Button asChild variant="outline" className="border-ff-blue text-ff-blue hover:bg-ff-blue hover:text-white">
          <Link to="/browse"><Compass className="mr-2 h-4 w-4" /> Browse fundraisers</Link>
        </Button>
      </div>
    </Container>
  );
}
